var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import ComponentTypeEndpoints from "src/shared/api/campaign/component/type/ComponentTypeEndpoints";
import { reactive } from "vue";
import { ComponentType } from "./model/ComponentType";
export const useComponentTypeStore = defineStore("componentTypeStore", () => {
    const state = reactive({
        defaultComponentTypes: {},
        clientComponentTypes: {},
    });
    const setDefaultComponentTypes = (responses) => {
        responses.forEach((response) => {
            state.defaultComponentTypes[response.name] = new ComponentType(response);
        });
    };
    const setClientComponentTypes = (responses) => {
        responses.forEach((response) => {
            state.clientComponentTypes[response.name] = new ComponentType(response);
        });
    };
    const fetchClient = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield ComponentTypeEndpoints.list();
        setClientComponentTypes(data);
    });
    const fetchDefault = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield ComponentTypeEndpoints.listDefault();
        setDefaultComponentTypes(data);
    });
    const listDefault = () => {
        return Object.values(state.defaultComponentTypes);
    };
    const listClient = () => {
        return Object.values(state.clientComponentTypes);
    };
    return {
        state,
        fetchDefault,
        fetchClient,
        listDefault,
        listClient,
    };
});
